import { isAxiosError } from 'axios'

export enum PrometheusSelectionSource {
  ALERT_URL = 'ALERT_URL',
  PROMQL = 'PROMQL',
  RULES = 'RULE'
}

export function getPrometheusMonitorUrl(
  promQl: string,
  integrationUrl: string
) {
  const params = getAlertUrlQueryParams(promQl)
  return `${integrationUrl}api/v1/query?${params}`
}

export function getAlertUrlQueryParams(promQL: string) {
  return `query=${encodeURIComponent(promQL)}`
}

export function extractPromQLFromMonitorUrl(monitorUrl: string) {
  try {
    const promQL = decodeURIComponent(monitorUrl).split('query?')[1]

    if (!promQL) return

    return promQL.slice(6) // Remove 'query='
  } catch (error) {
    return
  }
}

/**
 * Determine whether the Prometheus Rule search query should retry failed/errored requests.
 */
export function shouldRetryPredicateFn(error: unknown): boolean {
  if (!isAxiosError(error)) return false

  const errorCode = error.code ? parseInt(error.code) ?? 0 : 0
  const isInternalError = error.response?.data.status === 'error'

  return errorCode < 500 || !isInternalError
}
